import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";

import ReportHeaderTableRow from "./ReportHeaderTableRow";

const headerNames = [
    "Column Name",
    "Column Value",
]

const ReportHeaderTable = ({tableData, mentionVariables,updateCell,addRow,addColumn, inverted }) => {

    return (
      <div>
        <table className='table table-hover table-report-data'>
          <thead>
            <tr>
              <th className='row-index'></th>
              {
                tableData[0].map((item,index) => (
                  <th key={index}>{inverted ? headerNames[index] : (10 + index).toString(36).toUpperCase()}</th>
                ))
              }
            </tr>
          </thead>
          <tbody>
            {
              tableData.map((row, index) => (
                <ReportHeaderTableRow inverted={inverted} row={row} rowIndex={index} key={index} mentionVariables={mentionVariables} updateCell={updateCell}/>
              ))
            }
          </tbody>
        </table>

        { 
          addRow && 
          <button onClick={addRow}>Add Another Column</button>
        }
        { 
          addColumn && 
          <button onClick={addColumn}>Add Column</button>
        }
      </div>
    );
}

export default ReportHeaderTable;